"use strict";

(function (global, factory) {
  factory(require("../froala_3.0.5/js/froala_editor"));
})(void 0, function (FE) {
  "use strict";

  FE = FE && FE.hasOwnProperty("default") ? FE["default"] : FE;
  FE.DefineIcon("langIcon", {
    NAME: "globe",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpLang", {
    title: "Language",
    type: "dropdown",
    icon: "langIcon",
    options: {
      es: "Spanish",
      zh: "Chinese",
      tl: "Tagalog",
      vi: "Vietnamese",
      fr: "French",
      ko: "Korean",
      de: "German",
      ar: "Arabic",
      ru: "Russian",
      it: "Italian",
      pt: "Portuguese",
      hi: "Hindi",
      pl: "Polish",
      ja: "Japanese",
      ur: "Urdu",
      fa: "Persian",
      gu: "Gujarati",
      el: "Greek",
      bn: "Bengali",
      pa: "Panjabi",
      te: "Telugu",
      hy: "Armenian",
      he: "Hebrew",
      hmn: "Hmong",
      ht: "Haitian Creole"
    },
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function callback(cmd, val, params) {
      if (!this.selection.isCollapsed()) {
        this.format.remove("span");
        this.format.apply("span", {
          lang: val
        });
      }
    }
  });
});